import React, { memo } from 'react';
import classNames from 'classnames';
import s from './ExpandIcon.module.less';
import { ExpandMode } from '../../models';

type ExpandIconProps = {
  mode: ExpandMode;
  onClick: (event: React.MouseEvent) => void;
};

export const ExpandIcon = memo((props: ExpandIconProps) => {
  return (
    <button className={classNames(s.Wrap, props.mode === ExpandMode.MIXED && s.Mixed)} onClick={props.onClick}>
      {props.mode !== ExpandMode.MIXED && (
        <div
          className={classNames({
            [s.Toggle]: true,
            [s.Open]: props.mode === ExpandMode.CLOSED,
          })}
        />
      )}
    </button>
  );
});

ExpandIcon.displayName = 'MemoizedExpandedComponent';
